import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { User, Lock, X, GraduationCap, School, Building2, UserCircle, Phone, Shield, MapPin } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import SliderCaptcha from '../components/SliderCaptcha';
import { supabase } from '../supabase/client';

const regionData: Record<string, string[]> = {
  '北京': ['北京市'], '上海': ['上海市'], '天津': ['天津市'], '重庆': ['重庆市'],
  '河北': ['石家庄', '唐山', '秦皇岛', '邯郸', '邢台', '保定', '张家口', '承德', '沧州', '廊坊', '衡水'],
  '山西': ['太原', '大同', '阳泉', '长治', '晋城', '朔州', '晋中', '运城', '忻州', '临汾', '吕梁'],
  '辽宁': ['沈阳', '大连', '鞍山', '抚顺', '本溪', '丹东', '锦州', '营口', '阜新', '辽阳', '盘锦', '铁岭', '朝阳', '葫芦岛'],
  '吉林': ['长春', '吉林', '四平', '辽源', '通化', '白山', '松原', '白城', '延边'],
  '黑龙江': ['哈尔滨', '齐齐哈尔', '鸡西', '鹤岗', '双鸭山', '大庆', '伊春', '佳木斯', '七台河', '牡丹江', '黑河', '绥化', '大兴安岭'],
  '江苏': ['南京', '无锡', '徐州', '常州', '苏州', '南通', '连云港', '淮安', '盐城', '扬州', '镇江', '泰州', '宿迁'],
  '浙江': ['杭州', '宁波', '温州', '嘉兴', '湖州', '绍兴', '金华', '衢州', '舟山', '台州', '丽水'],
  '安徽': ['合肥', '芜湖', '蚌埠', '淮南', '马鞍山', '淮北', '铜陵', '安庆', '黄山', '滁州', '阜阳', '宿州', '六安', '亳州', '池州', '宣城'],
  '福建': ['福州', '厦门', '莆田', '三明', '泉州', '漳州', '南平', '龙岩', '宁德'],
  '江西': ['南昌', '景德镇', '萍乡', '九江', '新余', '鹰潭', '赣州', '吉安', '宜春', '抚州', '上饶'],
  '山东': ['济南', '青岛', '淄博', '枣庄', '东营', '烟台', '潍坊', '济宁', '泰安', '威海', '日照', '临沂', '德州', '聊城', '滨州', '菏泽'],
  '河南': ['郑州', '开封', '洛阳', '平顶山', '安阳', '鹤壁', '新乡', '焦作', '濮阳', '许昌', '漯河', '三门峡', '南阳', '商丘', '信阳', '周口', '驻马店'],
  '湖北': ['武汉', '黄石', '十堰', '宜昌', '襄阳', '鄂州', '荆门', '孝感', '荆州', '黄冈', '咸宁', '随州', '恩施'],
  '湖南': ['长沙', '株洲', '湘潭', '衡阳', '邵阳', '岳阳', '常德', '张家界', '益阳', '郴州', '永州', '怀化', '娄底', '湘西'],
  '广东': ['广州', '深圳', '珠海', '汕头', '佛山', '韶关', '湛江', '肇庆', '江门', '茂名', '惠州', '梅州', '汕尾', '河源', '阳江', '清远', '东莞', '中山', '潮州', '揭阳', '云浮'],
  '海南': ['海口', '三亚', '三沙', '儋州'],
  '四川': ['成都', '自贡', '攀枝花', '泸州', '德阳', '绵阳', '广元', '遂宁', '内江', '乐山', '南充', '眉山', '宜宾', '广安', '达州', '雅安', '巴中', '资阳', '阿坝', '甘孜', '凉山'],
  '贵州': ['贵阳', '六盘水', '遵义', '安顺', '毕节', '铜仁', '黔西南', '黔东南', '黔南'],
  '云南': ['昆明', '曲靖', '玉溪', '保山', '昭通', '丽江', '普洱', '临沧', '楚雄', '红河', '文山', '西双版纳', '大理', '德宏', '怒江', '迪庆'],
  '陕西': ['西安', '铜川', '宝鸡', '咸阳', '渭南', '延安', '汉中', '榆林', '安康', '商洛'],
  '甘肃': ['兰州', '嘉峪关', '金昌', '白银', '天水', '武威', '张掖', '平凉', '酒泉', '庆阳', '定西', '陇南', '临夏', '甘南'],
  '青海': ['西宁', '海东', '海北', '黄南', '海南', '果洛', '玉树', '海西'],
  '内蒙古': ['呼和浩特', '包头', '乌海', '赤峰', '通辽', '鄂尔多斯', '呼伦贝尔', '巴彦淖尔', '乌兰察布', '兴安', '锡林郭勒', '阿拉善'],
  '广西': ['南宁', '柳州', '桂林', '梧州', '北海', '防城港', '钦州', '贵港', '玉林', '百色', '贺州', '河池', '来宾', '崇左'],
  '西藏': ['拉萨', '日喀则', '昌都', '林芝', '山南', '那曲', '阿里'],
  '宁夏': ['银川', '石嘴山', '吴忠', '固原', '中卫'],
  '新疆': ['乌鲁木齐', '克拉玛依', '吐鲁番', '哈密', '昌吉', '博尔塔拉', '巴音郭楞', '阿克苏', '克孜勒苏', '喀什', '和田', '伊犁', '塔城', '阿勒泰'],
};

const unitTypes = [
  { value: 'school', label: '学校', icon: School },
  { value: 'institution', label: '机构', icon: Building2 },
  { value: 'individual', label: '个体', icon: UserCircle },
];

export default function Register() {
  const navigate = useNavigate();
  const [role, setRole] = useState<'student' | 'teacher'>('student');
  const [error, setError] = useState('');
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [showAuditModal, setShowAuditModal] = useState(false);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: '', phone: '', code: '', password: '', confirmPassword: '',
    province: '', city: '', unitType: '', unitName: ''
  });

  const sendCode = async () => {
    setError('');
    if (!captchaVerified) {
      setError('请先完成滑块验证'); return;
    }
    if (!/^1[3-9]\d{9}$/.test(form.phone)) {
      setError('请输入正确的手机号'); return;
    }

    try {
      const response = await supabase.functions.invoke('message-service', {
        body: { action: 'sms_send_code', phone: form.phone }
      });

      const data = response.data;
      const invokeError = response.error;

      if (invokeError) {
        alert('发送失败：' + (invokeError.message || '短信发送失败，请稍后重试'));
        setError(invokeError.message || '短信发送失败，请稍后重试');
        return;
      }

      if (!data) {
        alert('发送失败：服务器返回空数据');
        setError('短信发送失败，请稍后重试');
        return;
      }

      if (data.error) {
        alert('发送失败：' + data.error);
        setError(data.error);
        return;
      }

      if (!data.success) {
        alert('发送失败：' + (data.message || '短信发送失败，请稍后重试'));
        setError(data.message || '短信发送失败，请稍后重试');
        return;
      }

      alert('验证码已发送，请注意查收短信');
      setCountdown(60);
    } catch (err: any) {
      alert('发送失败：' + (err?.message || '短信发送失败，请稍后重试'));
      setError('短信发送失败，请稍后重试');
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!captchaVerified) { setError('请先完成人机验证'); return; }
    if (form.password !== form.confirmPassword) { setError('两次密码输入不一致'); return; }
    if (form.password.length < 6) { setError('密码至少6位'); return; }

    setLoading(true);
    try {
      const { data: verifyData, error: verifyError } = await supabase.functions.invoke('message-service', {
        body: { action: 'sms_verify_code', phone: form.phone, code: form.code }
      });

      if (verifyError) {
        setError(verifyError.message || '验证码验证失败');
        setLoading(false);
        return;
      }

      if (!verifyData || !verifyData.success) {
        setError(verifyData?.error || '验证码错误或已过期');
        setLoading(false);
        return;
      }

      const { data: existingAccount } = await supabase
        .from('user_accounts')
        .select('id, role')
        .eq('mobile', form.phone)
        .maybeSingle();

      if (existingAccount) {
        setError('该手机号已注册为其他角色账号，请更换手机号');
        setLoading(false);
        return;
      }

      const email = `${form.phone}@${role}.meoo.local`;
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email,
        password: form.password,
        options: {
          data: {
            username: form.name,
            mobile: form.phone,
            role: role
          }
        }
      });

      if (authError) {
        const errorMsg = authError.message;
        if (errorMsg.includes('already registered') || errorMsg.includes('User already registered')) {
          setError('该手机号已注册，请直接登录');
        } else {
          setError(errorMsg);
        }
        setLoading(false);
        return;
      }

      if (authData.user) {
        const userId = authData.user.id;

        let bindCode = '';
        if (role === 'teacher') {
          try {
            const { data: bindCodeData } = await supabase.functions.invoke('teacher-service', {
              body: { action: 'bind_code', teacherId: userId }
            });
            bindCode = bindCodeData?.bindCode || '';
          } catch (e) {
            // 生成绑定码失败，继续注册流程
          }
        }

        const { error: profileError } = await supabase.from('profiles').update({
          username: form.name,
          phone: form.phone,
          role: role,
          audit_status: role === 'teacher' ? 'pending' : 'approved',
          region: role === 'teacher' ? `${form.province} ${form.city}` : null,
          unit_type: role === 'teacher' ? form.unitType : null,
          unit_name: role === 'teacher' ? form.unitName : null,
          is_disabled: false,
          is_banned: false,
          bind_code: bindCode || null
        }).eq('id', userId);

        if (profileError) {
          await supabase.auth.admin.deleteUser(userId);
          setError('注册失败：' + profileError.message);
          setLoading(false);
          return;
        }

        const { error: accountError } = await supabase.from('user_accounts').insert({
          mobile: form.phone,
          role: role,
          password_hash: form.password,
          auth_user_id: userId,
          username: form.name,
          status: 'approved',
        });

        if (accountError) {
          await supabase.auth.admin.deleteUser(userId);
          setError('注册失败：' + accountError.message);
          setLoading(false);
          return;
        }

        if (role === 'teacher') {
          setShowAuditModal(true);
        } else {
          setError('');
          setShowAuditModal(true);
        }
      }
    } catch {
      setError('注册失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50 flex items-center justify-center py-12 px-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md bg-white rounded-2xl p-8 shadow-xl">
        <button onClick={() => navigate('/')} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600">
          <X className="w-5 h-5" />
        </button>

        <div className="text-center mb-6">
          <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center mx-auto mb-4">
            <GraduationCap className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">注册</h1>
        </div>

        <div className="flex gap-2 mb-6">
          <button onClick={() => setRole('student')} className={`flex-1 py-2 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-2 ${role === 'student' ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
            <User className="w-4 h-4" />学员注册
          </button>
          <button onClick={() => setRole('teacher')} className={`flex-1 py-2 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-2 ${role === 'teacher' ? 'bg-purple-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
            <School className="w-4 h-4" />教师注册
          </button>
        </div>

        {error && <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">{error}</motion.div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <AnimatePresence mode="wait">
            {role === 'teacher' && (
              <motion.div key="teacher-fields" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="space-y-4">
                <div className="grid grid-cols-2 gap-2">
                  <select value={form.province} onChange={e => setForm({ ...form, province: e.target.value, city: '' })} className="w-full px-3 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" required>
                    <option value="">选择省份</option>
                    {Object.keys(regionData).map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                  <select value={form.city} onChange={e => setForm({ ...form, city: e.target.value })} className="w-full px-3 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" required disabled={!form.province}>
                    <option value="">选择城市</option>
                    {form.province && regionData[form.province]?.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div className="space-y-2">
                  <label className="text-sm text-gray-600">单位性质</label>
                  <div className="flex gap-2">
                    {unitTypes.map(type => (
                      <button key={type.value} type="button" onClick={() => setForm({ ...form, unitType: type.value })} className={`flex-1 py-2 rounded-lg text-sm font-medium transition-all flex items-center justify-center gap-1 ${form.unitType === type.value ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
                        <type.icon className="w-4 h-4" />{type.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="relative">
                  <Building2 className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                  <input type="text" value={form.unitName} onChange={e => setForm({ ...form, unitName: e.target.value })} className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="请输入单位名称" required />
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          <div className="relative">
            <User className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input type="text" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="请输入姓名" required />
          </div>
          <div className="relative">
            <Phone className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input type="text" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="请输入手机号" maxLength={11} required />
          </div>
          <div className="flex gap-2">
            <input type="text" value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} className="flex-1 px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="验证码" maxLength={6} required />
            <button type="button" onClick={sendCode} disabled={countdown > 0} className="px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 whitespace-nowrap">{countdown > 0 ? `${countdown}s` : '获取验证码'}</button>
          </div>
          <div className="relative">
            <Lock className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="请输入密码" required />
          </div>
          <div className="relative">
            <Shield className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input type="password" value={form.confirmPassword} onChange={e => setForm({ ...form, confirmPassword: e.target.value })} className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none" placeholder="确认密码" required />
          </div>
          <SliderCaptcha onVerify={setCaptchaVerified} />
          <button type="submit" disabled={loading} className="w-full py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg font-medium hover:from-blue-500 hover:to-cyan-400 transition-all disabled:opacity-50">
            {loading ? '注册中...' : '注册'}
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link to="/login" className="text-blue-600 hover:text-blue-700 text-sm">已有账号？去登录</Link>
        </div>
      </motion.div>

      {showAuditModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} className="bg-white rounded-2xl p-6 w-96 text-center">
            <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${role === 'teacher' ? 'bg-blue-100' : 'bg-green-100'}`}>
              {role === 'teacher' ? <MapPin className="w-8 h-8 text-blue-500" /> : <Shield className="w-8 h-8 text-green-500" />}
            </div>
            <h3 className="text-lg font-bold text-gray-800 mb-2">注册成功</h3>
            <p className="text-gray-600 mb-6">
              {role === 'teacher' ? '管理员会在24小时内审核，请关注短信通知！' : '恭喜您注册成功，现在可以登录使用了！'}
            </p>
            <button onClick={() => { setShowAuditModal(false); navigate('/login'); }} className={`w-full py-3 text-white rounded-lg ${role === 'teacher' ? 'bg-blue-600 hover:bg-blue-700' : 'bg-green-600 hover:bg-green-700'}`}>确定</button>
          </motion.div>
        </div>
      )}
    </div>
  );
}
